'use client';

// ОТКРЫТЬ ПЕРЕПИСКУ С ЧЕЛОВЕКОМ ИЗ ЛЮБОГО МЕСТА КАБИНЕТА (владелец 11.09.2026, П10г
// обхода: тап по контакту открывал список «Чатов» без переписки).
//
// ПОЧЕМУ НЕ АДРЕСОМ. Прежний путь один: `router.push('/app/messages/<id>')`, а раздел
// «Чаты» ловил адрес и открывал переписку. В приложении это не доезжало: пока едет
// переход на вкладку, список «Чатов» живёт своей жизнью (опрос, смена папки) — эффект
// адреса перезапускается, его уборщик глушит незавершённый запрос переписки, а повторно
// он уже не сработает (адрес свой ход считает сделанным). В журнале владельца 11.09
// (10:32:44.760 `accountTap ct:<id>` → 10:32:46.749 `configureTopBar title=«Чаты»`) видно
// ровно это: вкладка сменилась, `chatOpen` не пришёл вовсе.
//
// ПОЭТОМУ ПРОСЬБА — МОДУЛЬНАЯ, как просьба открыть родную страницу «Настроек»
// (`openNativeSettingsPage` в account-native.ts): одноразовая запись + событие. Раздел
// «Чаты» смонтирован — берёт её событием сразу; не смонтирован — заберёт при монтировании
// (переход на вкладку идёт следом), и переписку поднимет ТА ЖЕ рука раздела, что открывает
// её из списка. Второй руки открытия переписки в кабинете нет.
//
// БРАУЗЕР — ПРЕЖНИЙ АДРЕСНЫЙ ПУТЬ: `openDialogNative` вернёт false, и зовущий идёт
// `router.push('/app/messages/<id>')`, как раньше.

import { isNativeApp } from './native-app';

/** Событие просьбы: у него нет своих данных — они лежат в одноразовой записи ниже. */
export const OPEN_DIALOG_EVENT = 'scr-open-dialog';

let pending: { id: string; at: string } | null = null;

/**
 * ПОПРОСИТЬ ОТКРЫТЬ ПЕРЕПИСКУ. `at` — реплика, на которой надо встать (находка поиска);
 * пусто — переписка откроется обычным концом.
 *
 * Вернула false — брать просьбу некому (мы в браузере): зовущий идёт прежним адресом.
 */
export function openDialogNative(dialogId: string, at = ''): boolean {
  // ТОЛЬКО В ПРИЛОЖЕНИИ: в браузере адрес переписки — обычная страница, и человек вправе
  // на неё сослаться, открыть в новой вкладке и вернуться «назад».
  if (typeof window === 'undefined' || !dialogId || !isNativeApp()) return false;
  pending = { id: dialogId, at };
  window.dispatchEvent(new CustomEvent(OPEN_DIALOG_EVENT));
  return true;
}

/** Забрать просьбу (она одноразовая: взяли — больше её нет). */
export function takePendingDialog(): { id: string; at: string } | null {
  const want = pending;
  pending = null;
  return want;
}

// ── ВКЛАДКА «ЧАТЫ» УЖЕ АКТИВНА? (П19 обхода владельца 11.09.2026, круг 2) ────────────
//
// ПРИЧИНА ПО ЖУРНАЛУ. Просьбу раздел брал сразу, как она появилась, и родной экран
// переписки рождался ВО ВКЛАДКЕ «АККАУНТ»: `chatOpen` уходил за ~200 мс до того, как
// оболочка успевала сказать нативу `setActiveTab({key:'messages'})`. Человек видел, как
// чат открывается поверх «Аккаунта», а после смены вкладки исчезает вместе с ней.
//
// ПОЭТОМУ просьба исполняется ТОЛЬКО когда вкладка «Чаты» вправду активна: оболочка
// объявляет это здесь — ПОСЛЕ ответа моста, а не до, — и раздел ждёт объявления.

/** Событие «вкладка «Чаты» стала активной»: им отпускается отложенная просьба. */
export const DIALOG_TAB_EVENT = 'scr-dialog-tab';

/** Какая вкладка родного меню сейчас активна (пусто — ещё не объявляли). */
let activeTab = '';

/** Объявить активную вкладку (зовёт оболочка, shell.tsx). Своего состояния о вкладках у
 *  раздела «Чаты» нет — он спрашивает отсюда. */
export function tellActiveTab(key: string): void {
  if (typeof window === 'undefined' || activeTab === key) return;
  activeTab = key;
  if (key === 'messages') window.dispatchEvent(new CustomEvent(DIALOG_TAB_EVENT));
}

/**
 * Можно ли открывать переписку прямо сейчас. В браузере вкладок родного меню нет вовсе —
 * ждать нечего; в приложении ждём объявления оболочки.
 */
export function dialogTabActive(): boolean {
  if (typeof window === 'undefined' || !isNativeApp()) return true;
  return activeTab === 'messages';
}
